/**
 * Pick a dial for percent / 0–1 KPIs and comparison bars for everything else.
 */

import React from 'react';
import { KpiCompareCard } from './KpiCompareCard';
import { KpiGaugeCard } from './KpiGaugeCard';
import { usesDial, type KpiTile } from './types';

interface KpiTileCardProps {
  tile: KpiTile;
  t: (key: string) => string;
  onHide?: () => void;
}

export const KpiTileCard: React.FC<KpiTileCardProps> = ({ tile, t, onHide }) =>
  usesDial(tile) ? (
    <KpiGaugeCard tile={tile} t={t} onHide={onHide} />
  ) : (
    <KpiCompareCard tile={tile} t={t} onHide={onHide} />
  );
